const stripShortcodeParams = (shortcodeString: string): string => {
	if (shortcodeString.includes('?')) {
		shortcodeString = shortcodeString.split('?')[0];
	}

	if (shortcodeString.includes('/')) {
		shortcodeString = shortcodeString.split('/')[0];
	}

	if (shortcodeString.includes('&')) {
		shortcodeString = shortcodeString.split('&')[0];
	}

	return shortcodeString;
};

export const getYouTubeId = (url?: string | null): string | null => {
	if (url == null) {
		return null;
	}

	let str = url;
	str = str.replace(/^https?:\/\//, '');
	str = str.replace(/(?:[?#]t|\?start)=.*$/, '');

	const shortcodeRegExp = /(?:youtube:\/|(?:youtu|y2u)\.be)\//g;
	if (shortcodeRegExp.test(str)) {
		return stripShortcodeParams(str.split(shortcodeRegExp)[1]);
	}

	const shortsUrl = /\/shorts\//g;
	if (shortsUrl.test(str)) {
		return stripShortcodeParams(str.split(shortsUrl)[1]);
	}

	const inlineVideoRegExp = /\/v\/|\/vi\/|\/watch\//g;
	if (inlineVideoRegExp.test(str)) {
		const inlineid = str.split(inlineVideoRegExp)[1];
		return stripShortcodeParams(inlineid);
	}

	const vParamRegExp = /v=|vi=/g;
	if (vParamRegExp.test(str)) {
		const [, param] = str.split(vParamRegExp);
		const [firstParam] = param.split('&');
		return stripShortcodeParams(firstParam);
	}

	const webPParamRegExp = /\/an_webp\//g;
	if (webPParamRegExp.test(str)) {
		return stripShortcodeParams(str.split(webPParamRegExp)[1]);
	}

	const eFormatRegExp = /\/e\//g;
	if (eFormatRegExp.test(str)) {
		return stripShortcodeParams(str.split(eFormatRegExp)[1]);
	}

	const embedRegExp = /\/embed\//g;
	if (embedRegExp.test(str)) {
		return stripShortcodeParams(str.split(embedRegExp)[1]);
	}

	const usernameRegExp = /\/user\/([a-zA-Z\d]*)$/g;
	if (usernameRegExp.test(str)) {
		return null;
	}

	const userRegExp = /\/user\/(?!.*videos)/g;
	if (userRegExp.test(str)) {
		const elements = str.split('/').pop();
		return elements ? stripShortcodeParams(elements) : null;
	}

	const attrRegExp = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/;
	if (attrRegExp.test(str)) {
		const matches = str.match(attrRegExp);
		return matches ? stripShortcodeParams(matches[1]) : null;
	}

	return null;
};
